import React from 'react';
import { useSelector } from 'react-redux';
import GlobalDeleteDialog from '../../../../components/mui/Dialogue/GlobalDeleteDialog';
import { deleteTopic, getSmeSchedules } from '../../../../redux/features/smeSlice';

const DeleteTopic = ({ id, data }) => {
  const { loading } = useSelector((state) => state.sme);
  const { paginationData, openAnchor } = useSelector((state) => state.globalDataGrid);

  return (
    <GlobalDeleteDialog
      title={'Delete Topic'}
      deleteNote={'Are you sure? you want to delete this schedule topic..?'}
      api={deleteTopic({ sme_schedules_topic_ids: [id] })}
      upDateCall={getSmeSchedules(data)}
      loading={loading}
    />
  );
};

export default DeleteTopic;
